export default __webpack_public_path__ + "static/media/boxicons.6829ebb1.eot";